import cn from 'clsx';
import { useAchievementList } from "../../../shared/hooks";
import { usePlayroomAchievementsTranslations } from "../../hooks";
import HelpFlatCard from "../HelpFlatCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HelpBadges = function HelpBadges(_ref) {
  var organizationId = _ref.organizationId,
    className = _ref.className,
    dataTestid = _ref['data-testid'],
    style = _ref.style;
  var _useAchievementList = useAchievementList(organizationId),
    helpItems = _useAchievementList.data,
    loading = _useAchievementList.loading;
  var _usePlayroomAchieveme = usePlayroomAchievementsTranslations(),
    t = _usePlayroomAchieveme.t;
  if (!loading && helpItems.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("section", {
    className: cn('dark:tw-text-neutral-light-100', className),
    "data-testid": dataTestid,
    style: style,
    children: [/*#__PURE__*/_jsx("h2", {
      className: "tw-font-subtitle4 tw-mb-2",
      children: t('PAS_HELP_SECTION_TITLE')
    }), /*#__PURE__*/_jsx("div", {
      role: "grid",
      className: "tw-grid tw-gap-1.6 tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4",
      children: helpItems.map(function (item, index) {
        return /*#__PURE__*/_jsx(HelpFlatCard, {
          label: item.eventName,
          coins: item.eventValue,
          "data-testid": "playroom-help-badge-item-".concat(index)
        }, item.id);
      })
    })]
  });
};
export default HelpBadges;